import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import LinkComponent from './LinkComponent'
// import '../public/images/bangkok.png'

const LargeSwiperImage = ({ title, imageSrc, type, location, color }) => {
    console.log(color)
    return (
        <LinkComponent href={`/properties?${type}=${location}`} className='relative w-full'>
            <div className='w-full h-[190px] relative overflow-hidden rounded-md'>
                <Image
                    src={imageSrc}
                    fill={true}
                    className='object-cover'
                    alt={title}
                // style={{ objectFit: "contain" }}
                />
                <div className='absolute h-full w-full bg-black/40'></div>
                <div className="absolute w-full text-center z-80 lg:text-xl text-lg top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                    <span className="relative inline-block px-1 text-light">
                        {title}

                        {color && (
                        <div
                            className="absolute left-0 -bottom-1 h-[1px] w-full -z-10"
                            style={{ backgroundColor: color }}
                        />
                        )}
                    </span>
                </div>
            </div>
        </LinkComponent>
    )
}

export default LargeSwiperImage